import React, { Component } from 'react';
import Select from 'react-select'
import clsx from 'clsx';
import { Typography, withStyles } from "@material-ui/core";

const styles = theme => ({
    labelWrapper: {
        width: '100%',
        display: 'flex',
    },
    label: {
        color: '#878787',
        flex: 1,
        fontSize: 12,
    },
    select: {
        width: '100%',
        height: '45px',
        // marginBottom: '20px',
        marginTop: '7px',
    },
    padding: {
        padding: '0px',
        '& path': {
            fill: '#6EA0D7'
        }
    },
    option: {
        fontSize: '10px',
        textAlign: 'left'
    }
})

class ReactSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            a: ''
        }
    }

    handleCloseMenuOnScroll = () => {
        this.setState({ a: '' });
        return false;
    }

    render() {
        const { onChange, labelText, labelColor, labelClass, classes, labelWrapperClass, selectClass, target, extraOnChange, error = false, ...other } = this.props;
        return (
            <React.Fragment>
                {labelText ?
                    <div className={clsx(classes.labelWrapper, labelWrapperClass)}>
                        <Typography className={clsx(classes.label, labelClass)} color={labelColor}>{labelText}</Typography>
                    </div>
                    : ''}
                <Select
                    className={clsx(classes.select, selectClass)}
                    // styles={AuxStyle}
                    onChange={selectedValue => onChange(target, selectedValue, extraOnChange)}
                    hideSelectedOptions={false}
                    menuPlacement="auto"
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                        control: base => ({ ...base, borderColor: error ? 'red' : '#E6EDF5' })
                    }}
                    menuPortalTarget={document.body}
                    closeMenuOnScroll={this.handleCloseMenuOnScroll}
                    {...other}
                    theme={theme => ({
                        ...theme,
                        borderRadius: 3,
                        borderColor: error ? 'red' : '#E6EDF5',
                        colors: {
                            ...theme.colors,
                            primary: '#E6EDF5',
                        },
                    })}
                />
            </ React.Fragment>
        );
    }
}

export default withStyles(styles)(ReactSelect);